import React, { useEffect, useRef, useState } from 'react';
import { Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation  } from 'react-router-dom';

export const NavBar = ({navVisible, windowWidth}) => {

    // Sticky Menu
    const [sticky, setSticky] = useState('');
    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => window.removeEventListener('scroll', stickNavbar);
    }, []);

    const stickNavbar = () => {
        if (window !== undefined) {
        let windowHeight = window.scrollY;
        windowHeight > 300 ? setSticky('sticky') : setSticky('');
        }
    };

    // NavBar Active Color
    const location = useLocation();
    const [url, setUrl] = useState(null);
    useEffect(() => {
        setUrl(location.pathname);
    }, [location]);



    // Cloose NavBar Function
    const [isOpen, setIsOpen] = useState(false); // Navbar open/close state
   
    const navbarRef = useRef(null);
 
    // Toggle navbar function
    const toggleNavbar = () => {
        setIsOpen((prev) => !prev);

    };
 
    // Close navbar function
    const closeNavbar = () => {
        setIsOpen(false);
    };
 
    // Close navbar when clicking outside
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target) && event.target.id !== 'click-close' ) {
                closeNavbar();
            }
            
        };
 
        // Add event listener only when navbar is open
        if (isOpen) {
            document.addEventListener("mousedown", handleOutsideClick);
        }
 
        // Cleanup function (Removes event listener on unmount)
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
 
    }, [isOpen]); 


    // Adding active class to each Service dropdown item
    const getServiceLinkClass = (serviceUrl) => {
        return url === serviceUrl ? 'nav-link active p-0' : 'nav-link p-0';
    };

    // Function to check if any service page is active to set active class on "Services" title
    const isServiceActive = () => {
        const servicePaths = [
            '/web-development',
            '/eCommerce-development',
            '/mobile-application-development',
            '/cybersecurity',
            '/saas-development',
            '/it-infrastructure',
            '/information-database-security',
            '/artificial-intelligence',
            '/end-to-end',
        ];

        return servicePaths.includes(url);
    };
    
    
    return (
        <header>

            <nav className={`${sticky ? 'sticky ' : ''} 
            ${ windowWidth >= 992 ? (navVisible ? 'nav-hide' : 'nav-show') : '' }
            navbar navbar-expand-lg nav-bg position-relative`}>
                <div className="container">
                    <Link className="navbar-brand web_logo" to="/">
                        <img src="../assets/images/logo.svg" alt="" />
                    </Link>
                    {/* Navbar Toggler Button */}
                    <button
                        id="click-close" // Button Click close Id
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleNavbar} 
                        aria-controls="collapsibleNavbar"
                        aria-expanded={isOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon "></span>
                    </button>

                    {/* Navbar Links */}
                    <div className={`collapse navbar-collapse nav-position ${isOpen ? "show body-overflow" : ""}`} 
                        id="collapsibleNavbar"
                        ref={navbarRef} >
                        <Container className='p-0'>
                            <ul className="top-bg navbar-nav imuii-nav m-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <Link className={"nav-link" + (url === "/" ?" active" : "")} to="/" onClick={closeNavbar}>Home</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={"nav-link" + (url === "/about" ?" active" : "")} to="/about" onClick={closeNavbar}>About</Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link className={"nav-link" + (url === "/gdpr" ?" active" : "")} to="#" onClick={closeNavbar}>GDPR</Link>
                                </li> */}
                                <li className="nav-item servie-dropdown">
                                    <NavDropdown title="Services" className={isServiceActive() ? "active" : ""} id="basic-nav-dropdown">
                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/web-development")} to="/web-development" onClick={closeNavbar}>Web Development</Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/eCommerce-development")} to="/eCommerce-development" onClick={closeNavbar}>E-commerce Development</Link>
                                        </NavDropdown.Item> 

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/mobile-application-development")} to="/mobile-application-development" onClick={closeNavbar}>Mobile Application Development</Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/saas-development")} to="/saas-development" onClick={closeNavbar}>SAAS Development</Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/cybersecurity")} to="/cybersecurity " onClick={closeNavbar}>Cybersecurity </Link>
                                        </NavDropdown.Item>
                                        
                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/it-infrastructure")} to="/it-infrastructure" onClick={closeNavbar}>IT Infrastructure </Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/information-database-security")} to="/information-database-security" onClick={closeNavbar}>Information Database Security </Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/artificial-intelligence")} to="/artificial-intelligence" onClick={closeNavbar}>Artificial Intelligence </Link>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item as="div">
                                            <Link className={getServiceLinkClass("/end-to-end")} to="/end-to-end" onClick={closeNavbar}>End-to-End Business Solutions </Link>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </li>
                                <li className="nav-item">
                                    <Link className={"nav-link" + (url === "/career" ?" active" : "")} to="/career" onClick={closeNavbar}>Career</Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link className={"nav-link" + (url === "/on-demand-developers" ?" active" : "")} to="/on-demand-developers" onClick={closeNavbar}>On Demand Developers</Link>
                                </li> */}
                                <Link to='/contact' className='nav-link' onClick={closeNavbar}>
                                    <button className='fly-btn'>Fly With Us <img className='fly-img' src="../assets/images/fly-img.svg" alt="" /> </button>
                                </Link>
                            </ul>
                        </Container>
                    </div>
                </div>
            </nav>
        </header>
    ) 
}